// core/common/dataTable/index.tsx
import { useState } from "react";
import { Table } from "antd";
import type { DatatableProps } from "../../data/interface";

const Datatable: React.FC<DatatableProps> = ({
  columns,
  dataSource,
  Selection,
  pagination,
  onChange,
  onSearch,
  searchText = "",
   scroll,
}) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState<any[]>([]);
  // const [searchText, setSearchText] = useState<string>("");
 const [localSearch, setLocalSearch] = useState<string>(searchText);
 const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      onSearch?.(localSearch);
    }
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: (newKeys: any[]) => setSelectedRowKeys(newKeys),
  };

  return (
    <>
      <div className="table-top-data d-flex px-3 justify-content-between">
        <div className="page-range"></div>
        <div className="serch-global text-right">
          <input
            type="search"
            className="form-control form-control-sm mb-3 w-auto float-end"
           value={localSearch}
            placeholder="Search"
            onChange={(e) => setLocalSearch(e.target.value)}
            onKeyDown={handleKeyDown}
            // prefix={<SearchOutlined />}
          />
        </div>
      </div>

      <Table
        className="table datanew dataTable no-footer"
        columns={columns}
        // rowHoverable={true}
        rowSelection={Selection ? rowSelection : undefined}
        dataSource={dataSource}
        pagination={pagination}
        onChange={onChange} // 🔹 call parent when page/sort changes
        scroll={scroll}
      />
    </>
  );
};

export default Datatable;
